import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import YouTube from 'react-youtube';
import { Modal } from '@/components/modal';
import { logEvent } from '@/analytics/events';
interface VideoModalProps {
  videoId: string;
  autoplay?: boolean;
  isOpened?: boolean;
  handleClose: () => void;
}
export function VideoModal(props) {
  const $ = _c(16);
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const t0 = props.autoplay ? 1 : 0;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      height: isMobile ? "220" : "657",
      width: isMobile ? "390" : "1168",
      playerVars: {
        autohide: 1,
        autoplay: t0,
        color: "white",
        ecver: 0,
        rel: 0,
        showinfo: 0,
        controls: 1,
        disablekb: 1
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const videoOptions = t1;
  const t2 = Boolean(props.isOpened);
  let t3;
  let t4;
  let t5;
  if ($[2] !== props.videoId) {
    t3 = () => {
      logEvent("video", {
        action: "play",
        content_id: props.videoId
      });
    };
    t4 = () => {
      logEvent("video", {
        action: "finish",
        content_id: props.videoId
      });
    };
    t5 = () => {
      logEvent("video", {
        action: "pause",
        content_id: props.videoId
      });
    };
    $[2] = props.videoId;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props.videoId || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== videoOptions) {
    t6 = <YouTube videoId={props.videoId} opts={videoOptions} className="aspect-video w-full overflow-hidden md:rounded-2xl" onPlay={t3} onEnd={t4} onPause={t5} />;
    $[6] = props.videoId;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = videoOptions;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props.handleClose || $[13] !== t2 || $[14] !== t6) {
    t7 = <Modal isVisible={t2} onClose={props.handleClose} modalName="videoModal" analyticsParam="videoModal" testId="videoModal" className="inset-0 w-[73rem] max-w-full! bg-transparent! p-0 md:max-w-[calc(100%-6rem)]!" backdropClassName="bg-opacity-90" closeButtonClassName="text-white -top-8! right-2 md:-right-8! bg-transparent w-auto h-auto">{t6}</Modal>;
    $[12] = props.handleClose;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}